// src/pages/SuperAdmin/BusinessCreatePage.tsx - Page création business (UX refactor)

import React from 'react';
import { Breadcrumb, Typography } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import CreateBusinessModal from './components/CreateBusinessModal';

const { Title } = Typography;

const BusinessCreatePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '24px' }}>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[
          { title: <Link to="/super-admin/businesses">Administration</Link> },
          { title: <Link to="/super-admin/businesses">Business</Link> },
          { title: 'Créer un business' },
        ]}
      />
      <Title level={3} style={{ marginBottom: 24 }}>
        <ShopOutlined style={{ color: '#722ed1', marginRight: 8 }} />
        Créer un nouveau Business
      </Title>
      <CreateBusinessModal
        visible
        renderAsPage
        onClose={() => navigate('/super-admin/businesses')}
        onSuccess={(businessId) => {
          navigate(businessId ? `/super-admin/businesses/${businessId}` : '/super-admin/businesses');
        }}
      />
    </div>
  );
};

export default BusinessCreatePage;
